import http from "./http.service"

 const CATEGORIES = `/categories`;
const MAIN_CATEGORIES = `/main-categories`;

export const categoryList = async () => {
  return http.get(`${CATEGORIES}`);
}

export const mainCategoryList = async () => {
  return http.get(`${MAIN_CATEGORIES}`);
}

export const subActivityList = async (categoryId: string) => {
  return http.get(`main-categories/${categoryId}/sub-activities`);
}

export const activityList = async (categoryId: string, subActivityId: string) => {
  return http.get(`main-categories/${categoryId}/sub-activities/${subActivityId}`);
}